import React, { Fragment } from 'react'
import IconPng from 'atoms/IconPng'
import { Label } from 'atoms/Texts'
import { BcContainer, BcLeft, BcRight, BcBottomBar } from './styles'
import { withTheme } from 'styled-components'

const ic_chevron_r = require('App/assets/images/ic_chevron_r.png')

const Breadcrumb = ({ navList, theme, children, ...rest }) => {
  const { getRGBA, mocaThinGrey } = theme
  return (
    <BcContainer {...rest}>
      <BcLeft>
        <Label lineheight={'29px'} mb={'5px'} size={'24px'}>
          {navList[(navList.length - 1)]}
        </Label>
        <BcBottomBar>
          {navList.map((li, i) =>
            <Fragment key={i}>
              <Label color={getRGBA(mocaThinGrey, 0.87)}>
                {li}
              </Label>
              {(i < (navList.length - 1)) &&
                <IconPng srcIcon={ic_chevron_r} mx={'8px'} size={'auto'} h={'11'} />
              }
            </Fragment>
          )}
        </BcBottomBar>
      </BcLeft>
      <BcRight>
        {children}
      </BcRight>
    </BcContainer>
  )
}

export default withTheme(Breadcrumb)
